import React,{useRef} from 'react';
import emailjs from '@emailjs/browser';
import swal from 'sweetalert';
import handshake from '../Assets/handshake.gif';

const Contact = () => {
    const form = useRef();

    const sendEmail = (e) => {
      e.preventDefault();
  
      emailjs.sendForm('service_xuc9bvq', 'template_cnuwqps', form.current, 'oCIWY6-LHOxVrwIj9')
        .then((result) => {
            if(result.text === "OK"){
                swal({
                    title: "Thanks",
                    text: "Your Message has been sent!",
                    icon: "success",
                    button: "Ok",
                  });
            }
        }, (error) => {
            console.log(error.text);
        });

        e.target.reset() 
    }
    return (
        <div name="contact" className='bg-[#1A1B1C] h-screen w-full flex justify-center items-center px-12 sm:px-0 '>
            <form ref={form} onSubmit={sendEmail} className="flex flex-col max-w-[600px] w-full">
                <div className='pb-8 flex flex-col justify-center items-center'>
                    <h1 className='inline border-b-4 text-2xl text-white border-teal-500'>Get In Touch</h1> <span><img src={handshake} alt="" /></span>
                    <p className='text-[#999999] pt-3'>I'd love if you reached out to me, Even if it's just to say Hey!. Drop me a line and i'll get back to you ASAP Or ping me on email <em className='font-semibold'>tanjib.cse@gmail.com</em></p>
                </div>
                

                <input className='p-2 rounded-md border bg-gray-100 px-4 focus:outline-none focus:ring-2 focus:ring-teal-400 caret-blue-500' placeholder='Name' type="text" name="user_name" required />
                <input className='p-2 my-3 rounded-md border bg-gray-100 px-4 focus:outline-none focus:ring-2 focus:ring-teal-400 caret-blue-500' placeholder='Email' type="email" name="user_email" required/>
                <textarea className='p-2 rounded-md border bg-gray-100 px-4 focus:outline-none focus:ring-2 focus:ring-teal-400 caret-blue-500' placeholder='Message' name="message" required/>
                <input type="submit" value="Send" className='px-12 py-3 mt-4 mx-auto cursor-pointer text-white bg-gradient-to-br from-green-400 to-blue-600 hover:bg-gradient-to-bl focus:ring-4 focus:outline-none focus:ring-green-200 dark:focus:ring-green-800 font-semibold rounded-lg' />
            </form>
        </div>
    );
};

export default Contact;